import React from 'react';
import { FormHelperText } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const CreateFormErrors: React.FC<any> = ({ errors, field }) => {
  const { t } = useTranslation();
  if (errors.length === 0) return null;
  return (
    <>
      {errors[field]?.type === 'required' && (
        <FormHelperText error>
          {t('app.common.language.required')}
        </FormHelperText>
      )}
    </>
  );
};
export default CreateFormErrors;
